<template>
  <article class="service-card h-100">
    <div class="service-card-heading">
      <div class="service-icon water-gradient">{{ icon }}</div>
      <span class="service-number">{{ number }}</span>
    </div>
    <div class="service-category">{{ categoryLabel }}</div>
    <h3 class="service-title">{{ title }}</h3>
    <p class="service-copy mb-0">{{ description }}</p>
  </article>
</template>

<script>
export default {
  name: "ServiceCard",
  props: {
    icon: String,
    title: String,
    description: String,
    category: String,
    number: Number
  },
  computed: {
    categoryLabel: function categoryLabel() {
      if (this.category) return this.category;
      if (this.number <= 5) return "Bảo trì & vận hành";
      if (this.number <= 10) return "Thi công & nâng cấp";
      return "Thương mại vật tư";
    }
  }
};
</script>

<style scoped>
.service-card {
  padding: 24px;
  background: #fff;
  border: 1px solid rgba(0, 61, 153, 0.08);
  border-radius: 22px;
  box-shadow: 0 14px 36px rgba(0, 61, 153, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 22px 44px rgba(0, 61, 153, 0.14);
}

.service-card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
}

.service-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.service-number {
  color: rgba(0, 61, 153, 0.28);
  font-size: 24px;
  font-weight: 800;
}

.service-category {
  display: inline-flex;
  margin-bottom: 12px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(0, 191, 255, 0.1);
  color: var(--water-blue);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.service-title {
  font-size: 18px;
  font-weight: 800;
  color: var(--water-blue);
  line-height: 1.45;
  margin-bottom: 10px;
}

.service-copy {
  color: var(--soft-text);
  font-size: 14px;
  line-height: 1.7;
}

@media (max-width: 575px) {
  .service-card {
    padding: 20px;
  }
}
</style>
